// eslint-disable-next-line @willow/import-react-html-parser
import ReactHtmlParser from 'react-html-parser';

import { sanitizeHtml } from '@willow/shared-iso';

export const sanitizeAndDisplayHtml = (htmlString: string): React.ReactNode => {
  return ReactHtmlParser(sanitizeHtml(htmlString));
};
